import React from 'react';
import { connect } from 'dva';
import { injectIntl } from 'react-intl';
import JsPlayer from '../components/player/JsPlayer';

export default connect(state => ({ ...state, loading: state.loading.global }))(
  injectIntl(({ loading, intl, dispatch }) => {
    return (
      <div className="container-player">
        <JsPlayer intl={intl} dispatch={dispatch} loading={loading} />
      </div>
    );
  })
);



// WEBPACK FOOTER //
// ./src/routes/Player.js